import mapData from "./v80UiToProtocolMap.json";
import {
  V80_FN_BLOCKED_POSITIONS,
  V80_FN_DEFAULT_EMPTY_POSITIONS,
} from "./v80Constants";

export type V80UiProtocolCell = {
  uiRow: number;
  uiCol: number;
  code: number;
  sn: number;
  idx: number;
};

const cells = mapData as V80UiProtocolCell[];

const byUi = new Map<string, V80UiProtocolCell>();
for (const c of cells) {
  byUi.set(`${c.uiRow}:${c.uiCol}`, c);
}

export function resolveV80ProtocolCell(
  uiRow: number,
  uiCol: number
): V80UiProtocolCell | undefined {
  return byUi.get(`${uiRow}:${uiCol}`);
}

export function protocolPos(sn: number, idx: number): number {
  return ((sn & 7) << 5) | (idx & 0x1f);
}

export function isV80FnBlockedPosition(pos: number): boolean {
  return V80_FN_BLOCKED_POSITIONS.some((p) => p === (pos & 0xff));
}

export function isV80FnDefaultEmptyPosition(pos: number): boolean {
  return V80_FN_DEFAULT_EMPTY_POSITIONS.some((p) => p === (pos & 0xff));
}
